//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'PaginationBasic',
  props: {
    pagination: {}
  },
  created: function created() {},
  methods: {
    goFirst: function goFirst() {
      this.pagination.current = 1;
      this.emitChange();
    },
    goNext: function goNext() {
      this.pagination.current++;
      this.emitChange();
    },
    goPrev: function goPrev() {
      this.pagination.current--;
      this.emitChange();
    },
    emitChange: function emitChange() {
      this.$emit('changePagina', this.pagination.current);
    }
  }
};